<script>
  export let campaign;
  import ItemList from './ItemList.svelte';
  import ButtonList from './ButtonList.svelte';
</script>


{#if campaign.image.length}
<img class="campaign-image" src="{campaign.image}"/>
{/if}
<h2>{campaign.title}</h2>
<div class="description-wrapper"><p class="description">{campaign.description} Organized by <ItemList items={campaign.organizers}/>.</p></div>
<h3 class="small-heading">Ways to donate</h3>
<p class="button-list donate-buttons"><ButtonList buttons={campaign.donateMethods}/></p>
{#if campaign.followMethods.length}
<h3 class="small-heading">Ways to follow</h3>
<p class="button-list follow-buttons"><ButtonList buttons={campaign.followMethods}/></p>
{/if}
<hr>

<style>
  .button-list {
    text-transform: uppercase;
  }
  .campaign-image {
    max-width: 300px;
  }
  .small-heading {
    text-transform: uppercase;
    font-weight: normal;
    font-size: 0.8em;
    color: #666;
  }
  .description-wrapper {
    margin: 0 auto 1.2em;
    max-width: 80%;
  }
  .description {
    margin: 0 auto 1.2em;
    max-width: 720px;
    font-weight: 300;
    color: #333;
  }
  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }

  hr {
    border-width: 0;
    background: #ddd;
    color: #ddd;
    height: 1px;
    margin: 30px 0;
  }

</style>
